import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AddUpdateOngoingComplianceModel, MiscellaneousFeeModel, OngoingComplianceModel } from 'src/Models/OngoingComplianceModel';
import { PricingQuotesService } from 'src/Services/pricing-quotes.service';
import { CheckAuth } from 'src/Services/utility.service';
import { checkStepIsCompletedVendor, getIncompletedStepVendor } from 'src/app/Shared/commonMethods';
import { Globle } from 'src/app/Shared/global';
import { AppConfig } from 'src/Services/app.config';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-client-price-quotes-compliance',
  templateUrl: './client-price-quotes-compliance.component.html',
  styleUrls: ['./client-price-quotes-compliance.component.css']
})
export class ClientPriceQuotesComplianceComponent implements OnInit {

  SelectedTool: string;
  userID: any;
  clientInformationId: number = 0;
  tokenKey: string;
  isloading: boolean = false;

  isShowprogressSpinner: boolean;
  blockedDocument: boolean;
  stateCode: any;
  isRecord: boolean = false;
  listofCompliance: OngoingComplianceModel[];
  listofMiscellaneousFees: MiscellaneousFeeModel[];
  listofAdditionalServices: any = [];
  complianceTotal: number = 0;
  companyName: string;

  addUpdateOngoingCompliance: AddUpdateOngoingComplianceModel =
    {
      OngoingCompliance: [],
      MiscellaneousFee: [],
      AdditionalServicesFee: [],
      priceQuoteId: 0
    };

  isCompanyProfileDetailsCompleted: boolean;
  isAddCompQueCompleted: boolean;
  isStateSelectionCompleted: boolean;
  isAddOnServicesCompleted: boolean;
  isComplianceDetailsCompleted: boolean;
  isAttechedDetailsCompleted: boolean;

  currentActiveTab: number = 1;

  url: string;
  tabId: number = 0;

  additionalServicesComplianeIdTemp: number = 1000000;

  mainUrl: string;
  subUrl: string;
  send_date = new Date();
  formattedDate: any;
  isSubmit: boolean = false;

  appModel: any;
  clientCompanyId: string;
  clientcompanyName: string;
  dbaCompanyName: string;
  priceQuoteId: number;

  constructor(private readonly router: Router, 
    private readonly PricingQuotesMaster: PricingQuotesService, 
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title, 
    private readonly activedRoute: ActivatedRoute, 
    private readonly toastr: ToastrService, 
    private readonly globle: Globle,
    private sessionStorageService: SessionStorageService) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.userID = sessionStorage.getItem('UserId');
    this.appModel = AppConfig.settings.ConnectionStrings;
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.clientCompanyId = sessionStorage.getItem('ClientCompanyId');
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.clientcompanyName = sessionStorage.getItem('ClientCompanyName');
    this.dbaCompanyName = sessionStorage.getItem('DbaCompanyName') == 'null' ? null : sessionStorage.getItem('DbaCompanyName');
    this.titleService.setTitle('Quote Request | JSi360');

    this.activedRoute.params.subscribe((params: Params) => {
      if (params['id']) {
        if (params['id'] != null) {
          this.priceQuoteId = params['id'];
          this.GetComplianceByClientInformationId(this.priceQuoteId);
        }
      }
    });

    this.mainUrl = '/View/';
    if (this.priceQuoteId != null) {
      this.GetProgressStepDetailsById(this.priceQuoteId)
      this.subUrl = getIncompletedStepVendor(this.globle.cApp.statusModel);
    }
    else {
      this.globle.cApp.statusModel.isCompanyProfileDetailsCompleted = null;
      this.globle.cApp.statusModel.isAddCompQueCompleted = null;
      this.globle.cApp.statusModel.isStateSelectionCompleted = null;
      this.globle.cApp.statusModel.isAddOnServicesCompleted = null;
      this.globle.cApp.statusModel.isComplianceDetailsCompleted = null;
      this.globle.cApp.statusModel.isNotes=null;
      this.subUrl = getIncompletedStepVendor(this.globle.cApp.statusModel);
    }
  }

  ngOnInit() {
    this.isloading = true;

  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  previousStep() {
    let navigation = '/View/client-quote-add-on-services/' + this.priceQuoteId;
    this.router.navigate([navigation]);
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }
  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  GetComplianceByClientInformationId(priceQuoteId) {
    this.blockDocument();
    this.PricingQuotesMaster.GetComplianceByClientInformationId(this.tokenKey, priceQuoteId).subscribe(
      data => {
        if (data['status'] = 'Success') {
          this.unblockDocument();
          this.isloading = false;
          this.listofCompliance = data['compliance'];
          if (this.listofCompliance != null) {
            if (this.listofCompliance.length == 0) {
              this.isRecord = true;
            }
            else {
              for (let iCounter = 0; iCounter < this.listofCompliance.length; iCounter++) {
                this.complianceTotal = this.complianceTotal + this.listofCompliance[iCounter].totalMonthlyCost;
              }
            }
          }
          else {
            this.isRecord = false;
          }

          this.listofMiscellaneousFees = data['miscellaneous'];
          if (this.listofMiscellaneousFees != null) {
            if (this.listofMiscellaneousFees.length == 0) {
              this.isRecord = true;
            }
          }
          else {
            this.isRecord = false;
          }
          this.listofAdditionalServices = data['additionalServices'];
          if (this.listofAdditionalServices != null) {
            if (this.listofAdditionalServices.length == 0) {
              this.isRecord = true;
            }
          }
          else {
            this.isRecord = false;
          }
        }

        else {
          this.unblockDocument();
          this.isRecord = false;
        }
      }, error => { this.stateCode = error }
    );
  }

  addRow() {
    this.additionalServicesComplianeIdTemp = this.additionalServicesComplianeIdTemp + 1;

    this.send_date.setMonth(this.send_date.getMonth());
    this.formattedDate = this.send_date.toISOString().slice(0, 10);

    this.listofAdditionalServices.push({
      additionalServicesComplianeId: this.additionalServicesComplianeIdTemp, additionalServicesTitle: '',
      additionalServicesNote: '', additionalServicesAmount: '', clientInformationId: this.userID,
      createdBy: 0, createdDate: this.formattedDate, updatedBy: 0, updatedDate: this.formattedDate, priceQuoteId: this.priceQuoteId, isSelected: false
    });
  }
  deleteRow(index) {
    this.listofAdditionalServices.splice(index, 1);
  }

  save() {
    this.blockDocument();
    this.isSubmit = true;
    let data = this.listofCompliance;
    this.globle.cApp.statusModel.isComplianceDetailsCompleted = false;
    for (let iCounter = 0; iCounter < this.listofCompliance.length; iCounter++) {
      this.listofCompliance[iCounter].createdBy = this.userID;
      this.listofCompliance[iCounter].clientInformationId = this.clientInformationId;
      this.listofCompliance[iCounter].priceQuoteId = this.priceQuoteId;
    }

      for (let iCounter = 0; iCounter < this.listofMiscellaneousFees.length; iCounter++) {
        this.listofMiscellaneousFees[iCounter].createdBy = this.userID;
        this.listofMiscellaneousFees[iCounter].clientInformationId = this.clientInformationId;
        this.listofMiscellaneousFees[iCounter].priceQuoteId = this.priceQuoteId;
  
        if(this.listofMiscellaneousFees[iCounter].miscellaneousTitle == "Notes"){
          if(this.listofMiscellaneousFees[iCounter].miscellaneousNote==null || this.listofMiscellaneousFees[iCounter].miscellaneousNote=="" || this.listofMiscellaneousFees[iCounter].miscellaneousNote==undefined)
          {
            if(this.listofMiscellaneousFees[iCounter].miscellaneousAmount!=null || this.listofMiscellaneousFees[iCounter].miscellaneousAmount!=undefined || this.listofMiscellaneousFees[iCounter].miscellaneousAmount==0){
            this.listofMiscellaneousFees[iCounter].isSelected = false;
            }
            this.listofMiscellaneousFees[iCounter].isSelected = false;
          }
  
          else{
            if(this.listofMiscellaneousFees[iCounter].miscellaneousNote!=null || this.listofMiscellaneousFees[iCounter].miscellaneousNote!=undefined || this.listofMiscellaneousFees[iCounter].miscellaneousNote!="")
            {
              if(this.listofMiscellaneousFees[iCounter].miscellaneousAmount==0 ){
              this.listofMiscellaneousFees[iCounter].isSelected = true;
              }
              else if(this.listofMiscellaneousFees[iCounter].miscellaneousAmount!=null || this.listofMiscellaneousFees[iCounter].miscellaneousAmount!=undefined)
              this.listofMiscellaneousFees[iCounter].isSelected = true;
              else if (this.listofMiscellaneousFees[iCounter].miscellaneousAmount==null || this.listofMiscellaneousFees[iCounter].miscellaneousAmount==undefined ||  this.listofMiscellaneousFees[iCounter].miscellaneousAmount.toString()!="") 
              this.listofMiscellaneousFees[iCounter].isSelected = true;
            }
            // this.listofMiscellaneousFees[iCounter].isSelected = true;
            else
             this.listofMiscellaneousFees[iCounter].isSelected = false;
          }
         
        }
  
      }
    for (let iCounter = 0; iCounter < this.listofAdditionalServices.length; iCounter++) {
      if (this.listofAdditionalServices[iCounter].additionalServicesTitle == ''){
        this.unblockDocument();
        return;
      }
      if (this.listofAdditionalServices[iCounter].additionalServicesNote == ''){
        this.unblockDocument();
        return;
      }
      this.listofAdditionalServices[iCounter].createdBy = this.userID;
      this.listofAdditionalServices[iCounter].clientInformationId = this.clientInformationId;
      this.listofAdditionalServices[iCounter].priceQuoteId = this.priceQuoteId;
    }

    this.addUpdateOngoingCompliance.OngoingCompliance = this.listofCompliance;
    this.addUpdateOngoingCompliance.MiscellaneousFee = this.listofMiscellaneousFees;
    this.addUpdateOngoingCompliance.AdditionalServicesFee = this.listofAdditionalServices;
    this.addUpdateOngoingCompliance.priceQuoteId = this.priceQuoteId;


    this.PricingQuotesMaster.ComlianceAddUpdate(this.addUpdateOngoingCompliance, this.tokenKey).subscribe(
      result => {
        this.unblockDocument();
        if (result['status'] == 'Success') {
          this.globle.cApp.statusModel.isComplianceDetailsCompleted = true;
          //this.router.navigate(['/admin/' + this.SelectedTool + '/proposal/' + this.priceQuoteId]);
          let navigation = '/View/client-notes/' + this.priceQuoteId;
          this.router.navigate([navigation]);
        }
        else {
          this.showMessage(result['status'], 'Error', 'error');
        }
      },
      error => {
        this.unblockDocument();
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  activeTab(url: string, tabId: number) {
    if (this.priceQuoteId != null) {
      if (checkStepIsCompletedVendor(url, this.globle.cApp.statusModel)) {
        this.currentActiveTab = tabId;
        let navigate = this.mainUrl + url + '/' + this.priceQuoteId;
        this.router.navigate([navigate]);
      }

      this.subUrl = getIncompletedStepVendor(this.globle.cApp.statusModel);
      if (url == this.subUrl) {
        this.currentActiveTab = tabId;
        let navigate = this.mainUrl + this.subUrl + '/' + this.priceQuoteId;
        this.router.navigate([navigate]);
      }
    }
    else {
      if (checkStepIsCompletedVendor(url, this.globle.cApp.statusModel)) {
        this.currentActiveTab = tabId;
        let navigate = this.mainUrl + url;
        this.router.navigate([navigate]);
      }

      this.subUrl = getIncompletedStepVendor(this.globle.cApp.statusModel);
      if (url == this.subUrl) {
        this.currentActiveTab = tabId;
        let navigate = this.mainUrl + this.subUrl;
        this.router.navigate([navigate]);
      }
    }
  }

  GetProgressStepDetailsById(priceQuoteId: number) {
    this.PricingQuotesMaster.GetProgressStepDetailsById(this.tokenKey, priceQuoteId).subscribe(
      result => {
        if (result['status'] == 'Success') {
          this.globle.cApp.statusModel = result['progress'];
          this.subUrl = getIncompletedStepVendor(this.globle.cApp.statusModel);
          this.activeTab('client-quote-compliance', 8);
        }
      });
  }

  SelectMiscellaneousItem(item) {

  }
}
